<script lang="ts">
    export let metaDescription: string | null = null;
    export let title: string | null = null;
</script>

<svelte:head>
    <title>{`${title ? title + ' | ' : ''}Junction Travel`}</title>
    {#if metaDescription}
        <meta name="description" content={metaDescription?.replace(/<\/?[^>]+(>|$)/g, '')} />
    {/if}
</svelte:head>
